import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import CreativesListScreen from "./creativeScreens/CreativesListScreen";
import UploadCreativeScreen from "./creativeScreens/uploadCreativeScreen";

import { useCreatives } from "../../../context/CreativeContext";
import ReplaceCreativeScreen from "./creativeScreens/replaceCreativeScreen";

const Creatives: React.FC = () => {
  const { creatives } = useCreatives();

  // Conditional redirect based on creatives count
  const ConditionalRedirect = () => {
    if (creatives.length > 0) {
      return <Navigate to="/creatives/list" replace />;
    } else {
      return <Navigate to="/creatives/upload" replace />;
    }
  };

  return (
    <Routes>
      {/* Default route redirects conditionally */}
      <Route path="/" element={<ConditionalRedirect />} />

      {/* Upload Creative Screen */}
      <Route path="/upload" element={<UploadCreativeScreen />} />

      {/* List Creatives Screen */}
      <Route path="/list" element={<CreativesListScreen />} />

      {/* Replace Creative Screen - New route */}
      <Route path="/replace/:creativeId" element={<ReplaceCreativeScreen />} />

      {/* Fallback */}
      <Route path="*" element={<ConditionalRedirect />} />
    </Routes>
  );
};

export default Creatives;
